import Trans from 'next-translate/Trans';
import Link from 'next/link';
import clsx from 'clsx';

//types
import type { ComponentPropsWithoutRef } from 'react';

//utils
import faqUrl from '@/utils/urls/faqUrl';

//lib
import { url_faq_subscription } from '@/lib/urls/faqUrls';

export function FaqCTA({ className, ...restProps }: ComponentPropsWithoutRef<'p'>) {
    return (
        <p
            className={clsx(
                'font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf',
                className
            )}
            {...restProps}>
            <Trans
                i18nKey="settings:subscription_invoices_page.check_our_faq"
                components={{
                    link: (
                        <Link
                            className="font-GSemiBold text-icoBlue underline"
                            href={faqUrl(url_faq_subscription)}
                            target="_blank"
                            rel="help noopener noreferrer"
                        />
                    )
                }}
            />
        </p>
    );
}
